import { update } from 'state/util';

/**
 * Login state reducer
 *
 * Manages the 'auth' key on the state tree. Sets
 * the following keys:
 * {
 *   loggedIn: ...
 *   token: ...
 *   mesage: ...
 * }
 *
 * Where message is the resulting error/success message
 * sent back from the API.
 */
const initialState = {
  loggedIn: false,
  token: null,
  message: null,
};

export const authReducer = (state, action) => {
  if (state === undefined) {
    return initialState;
  }

  switch(action.type) {
    case "LOGOUT_REQUESTED":
      return initialState;

    case "LOGIN_SUCCESSFUL":
      return update(state, {
        loggedIn: true,
        token: action.payload.auth.data.token,
        message: action.payload.auth.message,
      });

    case "LOGIN_FAILED":
      return update(state, {
        loggedIn: false,
        token: null,
        message: action.payload.message,
      });

    case "LOGIN_PENDING":
      return update(state, {
        message: "Logging in..."
      });

    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/state/auth/reducer.js